// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3c2MC","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__xS6iE"};